import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
// 用户基本信息(MemberSt)  https://doc.ixiaochuan.cn/pages/viewpage.action?pageId=125502041
export enum GenderEnum {
  girl = 1,
  man = 2,
  unknown = 3,
}
export interface MemberType {
  id: number
  zyid: string
  name: string
  gender: GenderEnum
  avatar_urls: {
    aspect_low: {
      urls: string[]
    }
  }
  aristocracy: {
    level: number
  }
}
// 赠送页面
export enum TabKey {
  following = 'following',
  followers = 'followers',
}

// [查看自己或者别人的粉丝列表](https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=2320509)
export const getMyFans = createAsyncThunk(
  'HiyaSendPage/getMyFans',
  async (
    p: {
      offset: number
      search_mid?: number
    } = {offset: 0},
    store: any
  ) => {
    const resp = await http.post('/live/attention/my_fans', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// [查看自己或者他人的关注列表](https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=2320627)
export const getMyAtts = createAsyncThunk(
  'HiyaSendPage/getMyAtts',
  async (
    p: {
      offset: number
      search_mid?: number
    } = {offset: 0},
    store: any
  ) => {
    const resp = await http.post('/live/attention/my_atts', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export interface InitialStateType {
  data: {
    [key in keyof typeof TabKey]: {
      more: boolean
      offset: number
      list?: MemberType[]
    }
  }
}

const initialState: InitialStateType = {
  data: {
    [TabKey.following]: {
      more: false,
      offset: 0,
      list: undefined,
    },
    [TabKey.followers]: {
      more: false,
      offset: 0,
      list: undefined,
    },
  },
}
export const SendPageSlice = createSlice({
  name: 'NormalSend',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMyFans.fulfilled, (state, action) => {
      const {data} = action.payload
      const {offset} = action.meta.arg
      Object.assign(state, {
        data: {
          ...state.data,
          [TabKey.following]: {
            more: data.more,
            offset: data.offset,
            list: !offset
              ? data.list
              : (state.data[TabKey.following].list || []).concat(data.list),
          },
        },
      })
    })
    builder.addCase(getMyAtts.fulfilled, (state, action) => {
      const {data} = action.payload
      const {offset} = action.meta.arg
      Object.assign(state, {
        data: {
          ...state.data,
          [TabKey.followers]: {
            more: data.more,
            offset: data.offset,
            list: !offset
              ? data.list
              : (state.data[TabKey.followers].list || []).concat(data.list),
          },
        },
      })
    })
  },
})

export default SendPageSlice.reducer
